<template>
  <div>
    <component
      :is="slice.slice_type"
      v-for="(slice, sliceIndex) in data.body"
      :key="sliceIndex"
      :slice="slice"
    />
  </div>
</template>

<script>
import {
  Hero,
  LogoBanner,
  GivebackSchema,
  HighlightSection,
  SimpleCta,
} from '@@/shared-slices'

import {
  TwitterTestimonials as TwitterTerstimonials, // yes, typo in custom type
  GivebackTimeline as giveback_timeline,
  AssociationsCarousel,
} from './components'

export default {
  name: 'GivebackModule',
  components: {
    hero: Hero,
    logo_banner: LogoBanner,
    giveback_schema: GivebackSchema,
    highlight_section: HighlightSection,
    TwitterTerstimonials,
    giveback_timeline,
    AssociationsCarousel,
    simple_cta: SimpleCta,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>
